import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  yard: 'Yard',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.yard],
  endpoints: {
    getYard: {
      providesTags: (_result, _error, { yardId }) => [{ type: TAG_TYPES.yard, id: yardId }],
    },
  },
})

export const { useGetYardQuery } = api
